export enum ClientActionsReportType {
  RISK = 'risk',
  OPPORTUNITY = 'opportunity',
}

export enum ClientActionsReportName {
  RISK = 'Risk',
  OPPORTUNITY = 'Opportunity',
}

export enum ClientActionsTypes {
  RISKS = 'risks',
  OPPORTUNITIES = 'opportunities',
}